import { ajax } from "../ajax";
import { ReqType as reqType } from "../config";
import { obj2formData } from "../../utils/objectUtils";

//保存码头账号API
export const saveApi = (data) => {
  return ajax("/sys/appointment/save", obj2formData(data), reqType.POST);
};

//码头列表API
export const listApi = async (params) => {
  return ajax("/sys/appointment/list", { ...params });
};

//删除码头账号API
export const deleteApi = async (id) => {
  return ajax("/sys/appointment/delete", { id });
};

//保存码头账号API
export const restartApi = (data) => {
  return ajax("/sys/appointment/restart", obj2formData(data), reqType.POST);
};
